import React, { useContext } from 'react';
import UPPage from '../components/UPPage';
import { useTranslation } from 'react-i18next';
import { GlobalErrorContext } from '../context';
import { redirect } from '../lib/Utils';
import { ValidateEmailForm } from '../components/ValidateEmailForm';
import { Typography } from '@mui/material';

/**
 * Forgot password page
 */
export const ForgotPassword = () => {
  const { t } = useTranslation('translation');
  const { setGlobalError } = useContext(GlobalErrorContext);

  return (
    <UPPage>
      <Typography component="h1" variant="h5" align="center">
        {t('passwordResetHeader')}
      </Typography>
      <ValidateEmailForm
        handleSuccess={() => redirect('/auth/recoveryEmailSent')}
        handleFailure={() => setGlobalError(t('validatePasswordError'))}
      />
    </UPPage>
  );
};
